import React from 'react'

function Error() {
  return (
    <div>
    error    
    </div>
  )
}

export default Error
